export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: object) => {
  try {
    sessionStorage.setItem('state', JSON.stringify(state));
  } catch {
    // ignore write errors
  }
};
